/* Packages */
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import $ from 'jquery';
import Plyr from 'plyr';
import RangeTouch from 'rangetouch';
import { IS_IOS } from '../constants';

/* Config */
import { defaultPlyrControls } from './plyr';

const isIOS = () =>
    ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform);

export const defaultFancyBoxSettings = {
    clickContent: false,
    loop: true,
    arrows: true,
    infobar: false,
    backFocus : false,
	smallBtn : false,
	thumbs : {
		autoStart : true,
		axis : 'x'
	},
	idleTime: 10,
	baseClass: IS_IOS ? 'fancybox-ios' : '',
    buttons: [
        "zoom",
        // "share",
        // "slideShow",
        "fullScreen",
        // "download",
        // "thumbs",
        "close"
    ],
    btnTpl: {
        arrowLeft:
            '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
            '<svg class="icon" viewBox="0 0 100 100"><path d="M23.66 55.744l41.046 41.775a8.129 8.129 0 0011.407-.215c3.126-3.176 3.22-8.296.21-11.587L41.077 49.852l35.248-35.807c3.224-3.259 3.236-8.556.028-11.83a8.144 8.144 0 00-11.646-.029L23.66 43.961a8.38 8.38 0 00-2.41 5.891 8.38 8.38 0 002.41 5.892z" class="arrow" transform="translate(100, 100) rotate(180)"></path></svg>' +
            "</button>",

        arrowRight:
            '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
            '<svg class="icon" viewBox="0 0 100 100"><path d="M23.66 55.744l41.046 41.775a8.129 8.129 0 0011.407-.215c3.126-3.176 3.22-8.296.21-11.587L41.077 49.852l35.248-35.807c3.224-3.259 3.236-8.556.028-11.83a8.144 8.144 0 00-11.646-.029L23.66 43.961a8.38 8.38 0 00-2.41 5.891 8.38 8.38 0 002.41 5.892z" class="arrow" transform="translate(100, 100) rotate(180)"></path></svg>' +
            "</button>",
    },
    afterClose: () => {
        document.documentElement.classList.remove('disable-scroll');
    }
}

Fancybox.bind("[data-fancybox]", {
    Carousel: {
        Navigation: {
            nextTpl:
                '<svg class="icon" viewBox="0 0 100 100"><path d="M23.66 55.744l41.046 41.775a8.129 8.129 0 0011.407-.215c3.126-3.176 3.22-8.296.21-11.587L41.077 49.852l35.248-35.807c3.224-3.259 3.236-8.556.028-11.83a8.144 8.144 0 00-11.646-.029L23.66 43.961a8.38 8.38 0 00-2.41 5.891 8.38 8.38 0 002.41 5.892z" class="arrow" transform="translate(100, 100) rotate(180)"></path></svg>',

            prevTpl:
                '<svg class="icon" viewBox="0 0 100 100"><path d="M23.66 55.744l41.046 41.775a8.129 8.129 0 0011.407-.215c3.126-3.176 3.22-8.296.21-11.587L41.077 49.852l35.248-35.807c3.224-3.259 3.236-8.556.028-11.83a8.144 8.144 0 00-11.646-.029L23.66 43.961a8.38 8.38 0 00-2.41 5.891 8.38 8.38 0 002.41 5.892z" class="arrow" transform="translate(100, 100) rotate(180)"></path></svg>',
        },
    },
    contentClick: false,
    loop: true,
    arrows: false,
    idle: 10000,
    baseClass: isIOS() ? 'fancybox-ios' : '',
    Toolbar: {
        display: {
            left: [],
            middle: [],
            right: ["iterateZoom", "fullscreen", "close"],
        },
    },
    Thumbs: {
        type: 'classic',
        thumbTpl: '<button type="button" class="f-thumbs__slide__button" aria-label="{{GOTO}}"></button>',
    },
    afterClose: () => {
        document.documentElement.classList.remove('disable-scroll');
    },
});

$('[data-fancybox-plyr]').each(function () {

    const plyrNode = document.getElementById(this.dataset.fancyboxPlyr);
    const fbSrcNode = document.getElementById(this.dataset.fancyboxSrc);

    let player;
    if (plyrNode !== null)
        player = new Plyr(plyrNode, {
            ...defaultPlyrControls,
            autoplay: false,
            muted: !window.matchMedia('(min-width: 991px)').matches,
            hideControls: window.matchMedia('(min-width: 991px)').matches
        });

        player.on('ready', () => {
            new RangeTouch(player.elements.inputs.seek);
        });

        player.on('playing', () => {
            player.elements.container.style.opacity = 1;
        });

	$(this).on('click', function () {
        const paneFancybox = new Fancybox(
            [
                {
                    src:fbSrcNode,
                    type: "html",
                },
            ],
            {
                Carousel: {
                    classes: {
                        container: "fancybox__carousel fancybox__carousel--sulu",
                        slide: "fancybox__slide",
                        track: "fancybox__track",
                        viewport: "fancybox__viewport",
                    }
                },
                Toolbar: {
                    display: {
                        left: [],
                        middle: [],
                        right: ["iterateZoom", "fullscreen", "close"],
                    },
                },
            }
        );

        paneFancybox.on('Carousel.ready', () => {
            // Temp solution
            setTimeout(() => {
                player.play();
            }, 1000)
        })
	});
});


